import { useEffect, useRef } from "react";


/**
 * Хук, выполняющий функции эквивалентные функциям inteval
 * сохраняя состояние между обновлениями функционального компонента
 *
 * @component
 */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Запоминание последнего callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Установка interval
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval ;
